import { Button } from "@/components/flexkit/Button";
import { IconUserAdd } from "@/assets/icons/geist/IconUserAdd";
import { type FC } from "react";

type NoMembersYetProps = {
    onAddPeopleClick: () => void;
};

export const NoMembersYet: FC<NoMembersYetProps> = ({ onAddPeopleClick }) => {
    return (
        <div className="flex flex-col items-center justify-center py-12">
            <div className="mb-3 flex size-12 items-center justify-center rounded-full bg-surface-secondary">
                <IconUserAdd size="sm" className="text-content-tertiary" />
            </div>
            <h3 className="mb-1 text-lg font-semibold text-content-primary">No members yet</h3>
            <p className="mb-4 max-w-sm text-center text-content-secondary">
                Add organization members to this group to get started.
            </p>
            <Button
                variant="primary"
                onClick={onAddPeopleClick}
                LeadingIcon={IconUserAdd}
                data-tracking-id="add-people"
            >
                Add People
            </Button>
        </div>
    );
};
